import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export const tasksApi = {
  list: async (status) => {
    const params = status && status !== "all" ? { status } : {};
    const res = await client.get("/tasks", { params });
    return res.data;
  },
  create: async (payload) => {
    const res = await client.post("/tasks", payload);
    return res.data;
  },
  update: async (id, payload) => {
    const res = await client.put(`/tasks/${id}`, payload);
    return res.data;
  },
  remove: async (id) => {
    const res = await client.delete(`/tasks/${id}`);
    return res.data;
  },
  summary: async () => {
    const res = await client.get("/tasks-stats/summary");
    return res.data;
  },
};
